<template>
  <div>
    <div class="question-box-intro-two"><h3>Details</h3></div>

    <AccountText
        v-model="form.text"
        :index="index"
        :noSave="noSave"
        :errorsPost="errorsPost.text"
        :giftDetails="form"
        :location="location"
        ref="accountText"
        :id="`${location}${index}text`"
    />

    <AccountType
        v-model="form.accountType"
        @input="$refs.accountText.setText()"
        :errors-post="errorsPost.accountType"
        :index="index"
        :no-save="noSave"
        :form="form"
        :location="location"
        :id="`${location}${index}accountType`"

    />

    <AccountNumber
        v-if="showAccountNumber"
        @input="$refs.accountText.setText()"
        v-model="form.accountNumber"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.accountNumber"
        :location="location"
        :id="`${location}${index}accountNumber`"
    />

    <AccountProvider
        v-if="showAccountProvider"
        @input="$refs.accountText.setText()"
        v-model="form.accountProvider"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.accountProvider"
        :location="location"
        :id="`${location}${index}accountProvider`"
    />

    <CustomText
        v-if="form.accountType === 'custom'"
        @input="$refs.accountText.setText()"
        v-model="form.userCustomText"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.userCustomText"
        :location="location"
        :id="`${location}${index}userCustomText`"
    />

    <TaxYN
        v-model="form.taxFree"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.taxFree"
        :location="location"
        :id="`${location}${index}taxFree`"
    />

    <ConditionYN
        v-model="form.conditionYN"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.conditionYN"
        :location="location"
        :id="`${location}${index}conditionYN`"
    />

    <Condition
        v-if="form.conditionYN"
        v-model="form.condition"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.condition"
        :location="location"
        :id="`${location}${index}condition`"
    />

    <Recipients
        v-model="form.recipients"
        :options-data="primaryOptions"
        :index="index"
        :no-save="noSave"
        :location="location"
        :errors-post="errorsPost.recipients"
        :id="`${location}${index}recipients`"
    />

    <ShareType
        v-if="recipientsMoreThanOne"
        v-model="form.shareType"
        :index="index"
        :no-save="noSave"
        :location="location"
        :gift-details="form"
        :eachOption="false"
        type-location="shareType"
        :id="`${location}${index}shareType`"
    />

    <ShareSeparatePercentages
        v-if="form.shareType === 'separate'"
        v-model="form.recipients"
        :index="index"
        :no-save="noSave"
        :location="location"
        :gift-details="form"
        shareLocation="recipients"
    />
    <div v-if="showPerStirpesOptions">
      <StirpesYN
          v-model="form.stirpes"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.stirpes"
          :location="location"
          :gift-details="form"
          :id="`${location}${index}stirpes`"
      />
      <StirpesAge
          v-if="form.stirpes"
          v-model="form.stirpesAge"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.stirpesAge"
          :location="location"
          :id="`${location}${index}stirpesAge`"
      />

    </div>

    <div v-show="showBackupOptions">
      <RecipientsBackupYN
          v-model="form.backupRecipientsYN"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.backupRecipientsYN"
          :location="location"
          :gift-details="form"
          :id="`${location}${index}backupRecipientsYN`"
      />

      <RecipientsBackup
          v-if="form.backupRecipientsYN"
          v-model="form.backupRecipients"
          :options-data="secondaryOptions"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          :errors-post="errorsPost.backupRecipients"
          :id="`${location}${index}backupRecipients`"
      />

      <ShareType
          v-if="backupRecipientsMoreThanOne"
          v-model="form.shareTypeBackup"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          :eachOption="false"
          type-location="shareTypeBackup"
          :id="`${location}${index}shareTypeBackup`"
      />

      <ShareSeparatePercentages
          v-if="form.shareTypeBackup === 'separate'"
          v-model="form.backupRecipients"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          shareLocation="backupRecipients"
      />
    </div>
  </div>
</template>

<script>
import {giftRecipientHelpers} from "../../../question/questions/will/gifts/giftRecipientHelpers";

import ConditionYN from "../../../question/questions/will/gifts/sub/ConditionYN";
import Condition from "../../../question/questions/will/gifts/sub/Condition";
import TaxYN from "../../../question/questions/will/gifts/sub/TaxYN";
import StirpesYN from "../../../question/questions/will/gifts/sub/StirpesYN";
import StirpesAge from "../../../question/questions/will/gifts/sub/StirpesAge";
import Recipients from "../../../question/questions/will/gifts/sub/Recipients";
import RecipientsBackup from "../../../question/questions/will/gifts/sub/RecipientsBackup";
import RecipientsBackupYN from "../../../question/questions/will/gifts/sub/RecipientsBackupYN";
import ShareType from "../../../question/questions/will/gifts/sub/ShareType";
import ShareSeparatePercentages from "../../../question/questions/will/gifts/sub/ShareSeparatePercentages";
import CustomText from "../../../question/questions/will/gifts/sub/CustomText";
import AccountText from "../../../question/questions/will/gifts/sub/AccountText";
import AccountType from "../../../question/questions/will/gifts/sub/AccountType";
import AccountNumber from "../../../question/questions/will/gifts/sub/AccountNumber";
import AccountProvider from "../../../question/questions/will/gifts/sub/AccountProvider";

export default {
  name: 'GiftAccount',
  components: {
    AccountProvider,
    AccountNumber,
    AccountType,
    AccountText,
    CustomText,
    ShareSeparatePercentages,
    ShareType,
    RecipientsBackupYN,
    RecipientsBackup,
    Recipients,
    StirpesAge,
    StirpesYN,
    TaxYN,
    Condition,
    ConditionYN
  },
  mixins: [giftRecipientHelpers],
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Object,
      default: () => {
        return {}
      }
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    },
    showAccountNumber() {
      return ['specificBank'].includes(this.form.accountType)
    },
    showAccountProvider() {
      return ['specificBank', 'stockShare', 'miniIsa', 'cashIsa', 'maxiIsa'].includes(this.form.accountType)
    }
  }
}
</script>